import { render, staticRenderFns } from "./csi-score.vue?vue&type=template&id=eb796166&scoped=true&"
import script from "./csi-score.vue?vue&type=script&setup=true&lang=js&"
export * from "./csi-score.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./csi-score.vue?vue&type=style&index=0&id=eb796166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.2_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.105.4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb796166",
  null
  
)

export default component.exports